/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssociatedDrug
 */
export interface AssociatedDrug {
    /**
     * 
     * @type {string}
     * @memberof AssociatedDrug
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssociatedDrug
     */
    name: string;
}

/**
 * Check if a given object implements the AssociatedDrug interface.
 */
export function instanceOfAssociatedDrug(value: object): value is AssociatedDrug {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AssociatedDrugFromJSON(json: any): AssociatedDrug {
    return AssociatedDrugFromJSONTyped(json, false);
}

export function AssociatedDrugFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssociatedDrug {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AssociatedDrugToJSON(json: any): AssociatedDrug {
    return AssociatedDrugToJSONTyped(json, false);
}

export function AssociatedDrugToJSONTyped(value?: AssociatedDrug | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

